import { cn } from '@/lib/cn';

/**
 * El cuerpo de una publicación o de un comentario: el ÚNICO sitio de la capa
 * React que produce marcado.
 *
 * Pasa por `Utils.renderPostContent` — el mismo saneador que usa el portal
 * vanilla y que limpió lo que ya está guardado. Reimplementarlo daría dos listas
 * blancas, y la que se quedara atrás sería la que decide qué entra en el DOM.
 *
 * `dangerouslySetInnerHTML` es deliberado y está acotado a esta función: todo lo
 * demás —nombres, cargos, áreas, audiencias, motivos— es texto de React, que
 * escapa por construcción. En la versión vanilla eran diez interpolaciones
 * crudas en plantillas de cadena en Novedades, y once más en Administración.
 *
 * ## Por qué vive en `components/` y no en `features/novedades/`
 *
 * Porque desde el 2026-09-25 lo usan dos pantallas: Novedades lo usa para el
 * cuerpo de una publicación y de un comentario, y Moderación para enseñar lo
 * que alguien denunció. Un `import` de una feature a otra lo habría resuelto
 * igual de bien hoy y habría dejado a Moderación dependiendo de Novedades para
 * siempre; lo vigila `test_novedades_pantalla.py::test_ninguna_feature_importa_de_otra`.
 */
export function ContenidoRico({ html, className }: { html: string; className?: string }) {
  return (
    <div
      className={cn('text-3 leading-relaxed text-ink break-words', className)}
      dangerouslySetInnerHTML={{ __html: Utils.renderPostContent(html) }}
    />
  );
}
